import styled, { css } from 'styled-components';
import theme from 'styled-theming';
import { H2, LabelRegular } from '@comeon/ui';

const dataAt = props => ({
	'data-at': props.dataAt
});

const HeadWrapper = styled.section.attrs(dataAt)`
	padding: ${({ padding }) => padding || '12px 12px 56px 12px'};
	text-align: ${({ align }) => align || 'center'};
	svg {
		fill: var(--section-head-main-icon);
		object-fit: fill;
		height: 56px;
		margin: 0 auto;
		width: 56px;
	}
	.page-head__close svg {
		width: 24px;
		height: 24px;
	}
`;

const MainTitle = styled(H2).attrs(dataAt)`
	color: ${props =>
		props.inverted
			? `var(--inverted-main-title, rgba(var(--base-11), 1))`
			: `var(--main-title, rgba(var(--base-02), 1))`};
	margin: 8px 0 2px 0;
	padding: ${({ padding }) => padding || '0 30px;'};
`;

const subTitleBrandException = theme('brand', {
	suomikasino: css`
		font-weight: normal;
	`
});

const SubTitle = styled(LabelRegular).attrs(dataAt)`
	color: ${props =>
		props.inverted
			? `var(--inverted-main-subtitle, rgba(var(--base-11), 1))`
			: `var(--main-subtitle, rgba(var(--base-02), 1))`};
	margin: 0 auto;
	max-width: ${({ maxWidth }) => maxWidth || '600px'};
	padding: ${({ padding }) => padding || '0 40px;'};
	${subTitleBrandException}
`;

const SubTitleLight = styled(LabelRegular).attrs(dataAt)`
	color: ${props =>
		props.inverted
			? `var(--inverted-main-title, rgba(var(--base-11), 1))`
			: `var(--main-title, rgba(var(--base-02), 1))`};
	margin: 0 auto;
	max-width: 600px;
	padding: 0 40px;
	${subTitleBrandException}
`;

const ActionContentWrapper = styled.div`
	margin-top: 20px;
`;

const SectionHead = ({ icon, title, subtitle, inverted, customPadding, actionContent, maxWidth }) => (
	<HeadWrapper className="section-head__head-wrapper" padding={customPadding}>
		{icon && icon}
		{title && <MainTitle inverted={inverted}>{title}</MainTitle>}
		{subtitle && (
			<SubTitle my={1} inverted={inverted} maxWidth={maxWidth}>
				{subtitle}
			</SubTitle>
		)}
		{actionContent && <ActionContentWrapper>{actionContent}</ActionContentWrapper>}
	</HeadWrapper>
);

export default SectionHead;

export { HeadWrapper, MainTitle, SubTitle, SubTitleLight };
